import type { Nullable } from '@iheartjane/types';

export const productSrcWidths = [100, 200, 400, 800, 1000, 1200];

export function imageSrcSet(
  src?: Nullable<string>,
  srcWidths: number[] = productSrcWidths,
  fallbackWidth?: number
) {
  fallbackWidth = fallbackWidth ?? srcWidths[0];

  if (src && src > '') {
    const url = new URL(src);
    const origin = url.origin;
    const pathname = url.pathname;
    const cloudflareBase = '/cdn-cgi/image/';
    const [first, ...rest] = srcWidths.sort((a, b) => a - b);
    const productSrcSizes = `(max-width: ${first}px)${rest.map(
      (r) => ` ${r}px`
    )}`;

    const cloudflareSrc = (resizeWidth: number, addPixelWidth?: boolean) => {
      const format = 'auto';

      const cloudflareOptions = `width=${resizeWidth},fit=scale-down,format=${format},metadata=none`;
      const srcSetPixelWidth = addPixelWidth ? ` ${resizeWidth}w` : '';

      // Check if this is an Ohio compliant image path
      const isOhioCompliant = pathname.startsWith('/c/oh/');

      if (isOhioCompliant) {
        // For Ohio compliant images, inject /resize/{options}/ after /compliant/us-oh/
        const parts = pathname.split('/c/oh/');
        const afterCompliant = parts[1];

        return (
          origin +
          '/c/oh/resize/' +
          cloudflareOptions +
          '/' +
          afterCompliant +
          srcSetPixelWidth
        );
      }

      // Default Cloudflare CDN path for non-compliant images
      return (
        origin +
        cloudflareBase +
        cloudflareOptions +
        pathname +
        srcSetPixelWidth
      );
    };

    const srcSetList = srcWidths.map((width) => cloudflareSrc(width, true));

    const fallbackSrc = cloudflareSrc(fallbackWidth);

    const srcSet = srcSetList.join(',');

    return { fallbackSrc, sizes: productSrcSizes, srcSet };
  }

  return undefined;
}
